import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import { textareaValidatorRequired } from "../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_DAMAGE]: yup.object({
    [ComponentId.INCIDENT_DAMAGE_DESCRIPTION]: textareaValidatorRequired(1000),
  }),
};
